<template>
    <Transition name="fade">
        <div v-if="showBanner" ref="banner" :style="`background-color: ${colors.background}`">
            <div class="mx-auto px-3 py-3">
                <div class="flex flex-wrap items-center justify-between">
                    <div class="flex flex-1 items-center">
                        <span
                            class="flex rounded-lg p-2 whitespace-normal brightness-90 filter"
                            :style="`background-color: ${colors.background}`"
                        >
                            <MegaphoneIcon class="h-6 w-6" :style="`color: ${colors.text}`" />
                        </span>

                        <p class="ml-3 truncate font-medium whitespace-normal" :style="`color: ${colors.text}`">
                            <span class="md:hidden"> {{ shortText ? shortText : text }} </span>
                            <span class="hidden md:inline"> {{ text }} </span>
                        </p>
                    </div>

                    <div v-if="buttonLink && buttonText" class="order-3 mt-2 w-full sm:order-2 sm:mt-0 sm:w-auto">
                        <button
                            @click="() => openLink(buttonLink)"
                            class="bg-button-dark-lightest text-text-base relative flex h-full w-full cursor-pointer items-center justify-center rounded-lg p-2 text-center text-xs font-bold hover:opacity-80"
                        >
                            {{ buttonText }}
                        </button>
                    </div>
                    <div class="order-2 sm:order-3 sm:ml-3">
                        <div class="ml-3 p-2" @click="closeBanner">
                            <XLightIcon
                                class="h-8 w-8 cursor-pointer hover:opacity-30"
                                :style="`color: ${colors.text}`"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import tailwind from '@/lib/tailwind'

import { MegaphoneIcon } from '@heroicons/vue/24/outline'
import XLightIcon from '@/components/icons/XLightIcon.vue'

const props = defineProps({
    name: {
        type: String,
        default: '',
    },
    title: {
        type: String,
        default: null,
    },
    text: {
        type: String,
        required: true,
    },
    shortText: {
        type: String,
        default: null,
    },
    buttonText: {
        type: String,
        default: null,
    },
    buttonLink: {
        type: [String, Function],
        default: null,
    },
    onClose: {
        type: Function,
        default: null,
    },
    level: {
        type: String,
        default: 'info',
    },
})
// Todo (Gaby - 30/12/21):V2: Enregistrer sur le local storage le fait que la banner a déjà été fermée
// onMounted(async () => {
// const isBannerAlreadyClosed = await Memory.get(`banner-${name}`)
const banner = ref(null)
const showBanner = ref(false)
// })
onMounted(() => {
    showBanner.value = true
}) //this way will play the animation

const closeBanner = () => {
    showBanner.value = false

    if (typeof props.onClose === 'function') {
        props.onClose()
    }
}

const colors = {
    text: tailwind.theme.color.white,
    background: tailwind.theme.color.banner?.[props.level],
}

const openLink = (buttonLink) => {
    if (typeof buttonLink === 'function') {
        buttonLink()
    } else {
        window.open(buttonLink, '_blank')
    }
}
</script>
